import { gql } from 'apollo-angular';

export const GET_CREDIT_CARDS = gql`
  query getCreditCards($search: String) {
    creditCards(search: $search) {
      id
      cardName
      cardNumberMasked
    }
  }
`;

export const GET_CREDIT_CARD_BY_ID = gql`
  query getCreditCardById($id: Int!) {
    creditCard(id: $id) {
      id
      cardName
      cardNumberMasked
    }
  }
`; 